import { Alert } from "@mui/material";
import { AlertProps } from "@mui/material/Alert";
import React from "react";

export default function RpAlert({ children, ...props }: AlertProps) {
  return <Alert {...props}>{children}</Alert>;
}
